import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { BusinessObject } from '../../../models';
import { CommonModule } from '@angular/common';
import { LibCoreLayoutModule } from '../../core-layout';
import { TranslateModule } from '@ngx-translate/core';
import { SalonServiceSelectionComponent } from '../../salon-service-selection';
import { MatButtonModule } from '@angular/material/button';

export interface ServiceSelectionDialogComponentData {
  businessObject: BusinessObject;
  selectedProductIds: number[];
  selectedTime: Date;
  disableSelectedProducts?: boolean;
}

@Component({
  selector: 'lib-service-selection-dialog',
  templateUrl: './service-selection-dialog.component.html',
  styleUrls: ['./service-selection-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    LibCoreLayoutModule,
    TranslateModule,
    SalonServiceSelectionComponent,
    ReactiveFormsModule,
    // material design
    MatButtonModule,
  ],
})
export class ServiceSelectionDialogComponent {
  public businessObject: BusinessObject;
  public selectedTime: Date;
  public originalSelectedProductIds: number[];
  public disableSelectedProducts: boolean;

  public selectedProductIdControl = new FormControl([], [Validators.required]);

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: ServiceSelectionDialogComponentData,
    private dialogRef: MatDialogRef<ServiceSelectionDialogComponent>
  ) {
    this.businessObject = this.data?.businessObject;
    this.selectedTime = this.data?.selectedTime;
    this.originalSelectedProductIds = this.data?.selectedProductIds || [];
    this.disableSelectedProducts = this.data?.disableSelectedProducts;
    this.selectedProductIdControl.setValue([
      ...(this.data?.selectedProductIds || []),
    ]);
  }

  public isAbleToSave(): boolean {
    return this.selectedProductIdControl.valid;
  }

  public save(): void {
    this.dialogRef.close(this.selectedProductIdControl.value);
  }

  public closeDialog(): void {
    this.dialogRef.close(null);
  }
}
